/**
 * 券「使用」跳转兜底：App / Web 分端路径（voucher 页、幸运转盘共用）
 */

/** @typedef {'AI_COPYTRADE'|'LOSS'|'DISCOUNT'} CouponNavFallbackKind */

/** @type {Record<CouponNavFallbackKind, { app: string, web: string }>} */
export const COUPON_NAV_FALLBACK = {
  AI_COPYTRADE: {
    app: "/aicopy",
    web: "/aicopy",
  },
  LOSS: {
    app: "/cfd/history",
    web: "/futures/record/btc_usdt_cfd",
  },
  DISCOUNT: {
    app: "/futures/usd-m?market=btc_usdt_cfd",
    web: "/futures/contract/btc_usdt_cfd",
  },
};

/**
 * @param {CouponNavFallbackKind|string|null|undefined} kind
 * @param {{ preferApp?: boolean }} [options]
 */
export function getCouponNavFallbackPath(kind, { preferApp = false } = {}) {
  const entry = COUPON_NAV_FALLBACK[kind];
  if (!entry) return "";
  return preferApp ? entry.app : entry.web;
}
